import type { Competition } from '@/api/spec.ts';
import type { TournamentEntry } from '../types';

export const TOURNAMENT_MOCKS_ENABLED = false;

/** Shows the "Dev: simulate/remove Monad Card" toggle on card-gated tournaments. Flip on to test the card gate. */
export const TOURNAMENT_DEV_CONTROLS_ENABLED = false;

// Sorted by the composite PnL×√volume score (desc), the way the backend returns the "psv" board.
export const MOCK_SCORE_ENTRIES: TournamentEntry[] = [
  {
    rank: 1,
    address: '0x21de...44a1',
    tradingVolume: 42_988_300,
    pnlPercentage: 264.9,
    pnl: 1_842_500,
    score: 12_080_000_000,
    prize: 12_000,
    isCurrentUser: false,
  },
  {
    rank: 2,
    address: '0x9a3f...1c08',
    tradingVolume: 18_421_900,
    pnlPercentage: 412.7,
    pnl: 1_310_200,
    score: 5_620_000_000,
    prize: 8_500,
    isCurrentUser: false,
  },
  {
    rank: 3,
    address: '0x5d17...c930',
    tradingVolume: 24_044_512,
    pnlPercentage: 132.1,
    pnl: 988_400,
    score: 4_845_000_000,
    prize: 6_000,
    isCurrentUser: false,
  },
  {
    rank: 4,
    address: '0x4c91...88ea',
    tradingVolume: 15_715_660,
    pnlPercentage: 178.6,
    pnl: 742_100,
    score: 2_940_000_000,
    prize: 4_500,
    isCurrentUser: false,
  },
  {
    rank: 5,
    address: '0x77b2...e419',
    tradingVolume: 7_109_220,
    pnlPercentage: 318.4,
    pnl: 611_900,
    score: 1_632_000_000,
    prize: 3_500,
    isCurrentUser: false,
  },
  {
    rank: 6,
    address: '0x3fab...7711',
    tradingVolume: 4_812_900,
    pnlPercentage: 118.8,
    pnl: 402_300,
    score: 882_000_000,
    prize: 2_800,
    isCurrentUser: false,
  },
  {
    rank: 7,
    address: '0xc3b1...2d44',
    tradingVolume: 3_204_881,
    pnlPercentage: 47.4,
    pnl: 288_050,
    score: 515_000_000,
    prize: 2_200,
    isCurrentUser: true,
  },
  {
    rank: 8,
    address: '0xd47b...5520',
    tradingVolume: 6_330_410,
    pnlPercentage: 92.4,
    pnl: 214_770,
    score: 540_000_000,
    prize: 1_800,
    isCurrentUser: false,
  },
  {
    rank: 9,
    address: '0xe8a0...02bb',
    tradingVolume: 1_902_775,
    pnlPercentage: 154.3,
    pnl: 121_640,
    score: 167_800_000,
    prize: 1_500,
    isCurrentUser: false,
  },
  {
    rank: 10,
    address: '0x6c2e...9b04',
    tradingVolume: 2_410_330,
    pnlPercentage: 103.5,
    pnl: 88_210,
    score: 137_000_000,
    prize: 1_200,
    isCurrentUser: false,
  },
  {
    rank: 11,
    address: '0x09d8...c451',
    tradingVolume: 4_120_550,
    pnlPercentage: 58.9,
    pnl: 41_880,
    score: 85_000_000,
    prize: null,
    isCurrentUser: false,
  },
  {
    rank: 12,
    address: '0x03fb...9065',
    tradingVolume: 28_410_220,
    pnlPercentage: -12.4,
    pnl: -320_140,
    score: -1_707_000_000,
    prize: null,
    isCurrentUser: false,
  },
];

export const MOCK_VOLUME_ENTRIES: TournamentEntry[] = [
  { rank: 1, address: '0x21de...44a1', tradingVolume: 42_988_300, pnlPercentage: 264.9, prize: 12_000, isCurrentUser: false },
  { rank: 2, address: '0x03fb...9065', tradingVolume: 28_410_220, pnlPercentage: -12.4, prize: 8_500, isCurrentUser: false },
  { rank: 3, address: '0x5d17...c930', tradingVolume: 24_044_512, pnlPercentage: 132.1, prize: 6_000, isCurrentUser: false },
  { rank: 4, address: '0x9a3f...1c08', tradingVolume: 18_421_900, pnlPercentage: 412.7, prize: 4_500, isCurrentUser: false },
  { rank: 5, address: '0x4c91...88ea', tradingVolume: 15_715_660, pnlPercentage: 178.6, prize: 3_500, isCurrentUser: false },
  { rank: 6, address: '0xb711...30dc', tradingVolume: 12_330_120, pnlPercentage: -26.6, prize: 2_800, isCurrentUser: false },
  { rank: 12, address: '0x09d8...c451', tradingVolume: 9_120_550, pnlPercentage: 58.9, prize: 2_200, isCurrentUser: false },
  { rank: 8, address: '0x77b2...e419', tradingVolume: 7_109_220, pnlPercentage: 318.4, prize: 1_800, isCurrentUser: false },
  { rank: 9, address: '0xd47b...5520', tradingVolume: 6_330_410, pnlPercentage: 92.4, prize: 1_500, isCurrentUser: false },
  { rank: 10, address: '0x3fab...7711', tradingVolume: 4_812_900, pnlPercentage: 118.8, prize: 1_200, isCurrentUser: false },
  { rank: 11, address: '0xc3b1...2d44', tradingVolume: 3_204_881, pnlPercentage: 47.4, prize: null, isCurrentUser: true },
  { rank: 13, address: '0x6c2e...9b04', tradingVolume: 2_410_330, pnlPercentage: 103.5, prize: null, isCurrentUser: false },
  { rank: 14, address: '0xb05c...f7d2', tradingVolume: 2_220_140, pnlPercentage: 201.2, prize: null, isCurrentUser: false },
  { rank: 15, address: '0xd91e...44a0', tradingVolume: 2_044_910, pnlPercentage: 11.2, prize: null, isCurrentUser: false },
  { rank: 16, address: '0xe8a0...02bb', tradingVolume: 1_902_775, pnlPercentage: 154.3, prize: null, isCurrentUser: false },
  { rank: 17, address: '0x83ce...1192', tradingVolume: 1_540_220, pnlPercentage: 71.8, prize: null, isCurrentUser: false },
  { rank: 18, address: '0xfe09...77bc', tradingVolume: 1_330_640, pnlPercentage: 36.8, prize: null, isCurrentUser: false },
  { rank: 19, address: '0x88dd...12fa', tradingVolume: 1_120_990, pnlPercentage: -2.8, prize: null, isCurrentUser: false },
  { rank: 20, address: '0x12fe...aa19', tradingVolume: 1_088_220, pnlPercentage: 88.7, prize: null, isCurrentUser: false },
  { rank: 21, address: '0x9b40...37c8', tradingVolume: 980_115, pnlPercentage: 81.2, prize: null, isCurrentUser: false },
  { rank: 22, address: '0x44a8...e310', tradingVolume: 902_440, pnlPercentage: 28.1, prize: null, isCurrentUser: false },
  { rank: 23, address: '0x6e72...9af0', tradingVolume: 880_300, pnlPercentage: 51.2, prize: null, isCurrentUser: false },
  { rank: 24, address: '0xaf21...0b67', tradingVolume: 720_880, pnlPercentage: 64.3, prize: null, isCurrentUser: false },
  { rank: 25, address: '0x2f0a...c8b1', tradingVolume: 681_700, pnlPercentage: 4.6, prize: null, isCurrentUser: false },
];

export const MOCK_COMPETITIONS: Competition[] = [
  {
    slug: 'monad-invitational',
    name: 'Monad Invitational',
    starts_at: 1783900800000,
    ends_at: 1784505600000,
    vol_min_volume: '1000000',
    roi_min_volume: '1000000',
    pnl_min_volume: '1000000',
    psv_min_volume: '1000000',
    pool_amount: '50000000000',
    vol_pool_distribution_bps: [2400, 1700, 1200, 900, 700, 560, 440, 360, 300, 240],
    roi_pool_distribution_bps: [3000, 2000, 1400, 1000, 700, 500, 400, 350, 300, 250],
    pnl_pool_distribution_bps: [2800, 1900, 1300, 950, 720, 560, 430, 350, 290, 240],
    psv_pool_distribution_bps: [2800, 1900, 1300, 950, 720, 560, 430, 350, 290, 240],
    results_finalized: false,
    ver: 1,
  },
];

export const MOCK_LEADERBOARD_COMPETITION_SLUG = 'monad-invitational';

/** Supplemental catalog for `mergeCompetitionCatalog`: the mock rounds on localhost, else nothing. */
export const getMockCompetitions = (): Competition[] => (TOURNAMENT_MOCKS_ENABLED ? MOCK_COMPETITIONS : []);
